import type { Fetcher, Key } from 'swr';
import useSWR, { type SWRConfiguration, type SWRResponse } from 'swr';

/**
 * リモートデータをフェッチするhook
 *
 * useSWRのラッパー。suspenseモードでonSuccess/onErrorがundefinedの場合に
 * 無限ループが発生する問題を回避するため、undefinedのオプションを除外する。
 *
 * @see https://swr.vercel.app/ja/docs/api
 */
export const useFetch = <Data, Error = unknown>(
  key: Key,
  fetcher: Fetcher<Data> | null,
  config?: SWRConfiguration<Data, Error>
): SWRResponse<Data, Error> => {
  const sanitizedConfig: SWRConfiguration<Data, Error> | undefined = config
    ? (() => {
        const entries = Object.entries(config);
        const filtered = entries.filter(([, v]) => v !== undefined);
        return filtered.length === entries.length
          ? config
          : (Object.fromEntries(filtered) as SWRConfiguration<Data, Error>);
      })()
    : config;

  return useSWR<Data, Error>(key, fetcher, sanitizedConfig);
};
